import script from "./EditProductDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProductDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EditProductDialog.vue?vue&type=style&index=0&id=68d38d8f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d38d8f"]])

export default __exports__